"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILTER_COLORS = exports.DEFAULT_FILTER_COLOR = void 0;
const DEFAULT_FILTER_COLOR = 'rgba(0, 0, 0, 0)';
exports.DEFAULT_FILTER_COLOR = DEFAULT_FILTER_COLOR;
const FILTER_COLORS = [DEFAULT_FILTER_COLOR, 'rgba(185, 137, 255, 0.5)', 'rgba(85, 90, 149, 0.5)', 'rgba(0, 0, 0, 0.5)', 'rgba(92, 146, 255, 0.5)', 'rgba(49, 186, 250, 0.5)', 'rgba(179, 30, 111, 0.5)', 'rgba(248, 75, 116, 0.5)', 'rgba(255, 0, 66, 0.5)', 'rgba(255, 151, 143, 0.5)', 'rgba(255, 113, 1, 0.5)', 'rgba(255, 239, 2, 0.5)', 'rgba(101, 206, 101, 0.5)', 'rgba(64, 235, 235, 0.5)', 'rgba(0, 188, 212, 0.5)', 'rgba(255, 255, 255, 0.5)'];
exports.FILTER_COLORS = FILTER_COLORS;